import { IconName } from "@dtm-frontend/shared/ui";
import { HELP_CENTER_URL } from "@dtm-frontend/shared/utils";

export const REGISTER_PANSA_URL = "https://register.uav.pansa.pl";
export const UAV_PANSA_URL = "https://uav.pansa.pl";
export const E_LEARNING_URL = "https://elearning.uav.pansa.pl";
export const E_IDENTIFICATION_URL = "http://cotulata.pl";
export const E_IDENTIFICATION_APP_PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=pl.pansa.uavidentification";
export const DRONE_TOWER_APP_PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=pl.pansa.dronetower";
export const DRONE_TOWER_APP_APPLE_STORE_URL = "https://apps.apple.com/app/id6477453743";
export const PANSA_FACEBOOK_URL = "https://www.facebook.com/groups/pansautm/";
export const PANSA_WHATSPAPP_URL =
    // eslint-disable-next-line max-len
    "https://www.whatsapp.com/channel/0029VajfsXV3LdQOutWukm2z";
export const REPORTING_VIOLATIONS_VIA_PANSA_URL = "https://www.pansa.pl/zglaszanie-naruszen/";
export const REPORTING_VIOLATIONS_VIA_CEUPT_URL = "https://www.cupt.gov.pl/kontakt/zglaszanie-nieprawidlowosci/";
export const FAQ_SECTION = "faq";

export const MAIN_PAGE_SERVICES_LIST: { link: string; labelTranslationKey: string; subLabelTranslationKey?: string }[] = [
    {
        link: "e-registration",
        labelTranslationKey: "dtmMainPageLib.menu.eRegistrationMenuItemLabel",
    },
    {
        link: "caa",
        labelTranslationKey: "dtmMainPageLib.menu.caaMenuItemLabel",
    },
    { link: "e-learning", labelTranslationKey: "dtmMainPageLib.menu.eLearningMenuItemLabel" },
    {
        link: "mission-planning",
        labelTranslationKey: "dtmMainPageLib.menu.missionPlanningMenuItemLabel",
    },
    {
        link: "three-areas",
        labelTranslationKey: "dtmMainPageLib.menu.threeAreasMenuItemLabel",
    },
    { link: "e-sora", labelTranslationKey: "dtmMainPageLib.menu.eSoraMenuItemLabel" },
    { link: "dss", labelTranslationKey: "dtmMainPageLib.menu.dssMenuItemLabel" },
    { link: "sah", labelTranslationKey: "dtmMainPageLib.menu.sahMenuItemLabel" },
    { link: "e-identification", labelTranslationKey: "dtmMainPageLib.menu.eIdentificationMenuItemLabel" },
    { link: "drone-tower", labelTranslationKey: "dtmMainPageLib.menu.droneTowerMenuItemLabel" },
];

export const MAIN_PAGE_KPO_PAGES_LIST: { link: string; labelTranslationKey: string }[] = [
    { link: "nrp/about-project", labelTranslationKey: "mainPage.header.kpo.aboutProjectLabel" },
    { link: "nrp/competition", labelTranslationKey: "mainPage.header.kpo.competitionLabel" },
    { link: "nrp/results", labelTranslationKey: "mainPage.header.kpo.resultsLabel" },
];

export const MAIN_PAGE_HELP_PAGES_LIST: {
    link: string;
    labelTranslationKey: string;
    iconName: IconName;
    subLabelTranslationKey?: string;
}[] = [
    {
        link: HELP_CENTER_URL,
        labelTranslationKey: "dtmMainPageLib.menu.help.helpCenterLabel",
        iconName: "question",
    },
    {
        link: PANSA_FACEBOOK_URL,
        labelTranslationKey: "dtmMainPageLib.menu.help.facebookLabel",
        iconName: "facebook",
    },
    {
        link: PANSA_WHATSPAPP_URL,
        labelTranslationKey: "dtmMainPageLib.menu.help.whatsappLabel",
        iconName: "whatsapp",
    },
];
